<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex><h1 class="display-2">Asignación permisos de Usuarios</h1></v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <user-select v-model="user_id" label="Seleccione usuario" @input="userSelected"></user-select>
            </v-flex>
            <v-flex>
                <v-btn :loading="actualizando" @click.native="actualizarPermisos">Actualizar permisos</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <v-autocomplete
                        prepend-icon="vpn_key"
                        color="green"
                        hide-selected
                        clearable
                        label="Permisos asignados"
                        item-value="id"
                        item-text="display_name"
                        v-model="permissions_id"
                        :items="permissions"
                        :loading="asignando"
                        @input="permissionSync"
                        multiple
                        chips
                >
                    <template slot="selection" slot-scope="data">
                        <v-chip
                                :selected="data.selected"
                                :key="JSON.stringify(data.item)"
                                close
                                class="chip--select-multi"
                                @input="data.parent.selectItem(data.item)"
                        >
                            {{ data.item.display_name }}
                        </v-chip>
                    </template>
                    <template slot="item" slot-scope="data">
                        <v-list-tile v-on="data.tile.on" v-bind="data.tile.props">
                            <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.display_name"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-autocomplete>
            </v-flex>
            <v-flex>
                <v-autocomplete
                        prepend-icon="group"
                        clearable
                        label="Roles asignados"
                        item-value="id"
                        item-text="display_name"
                        v-model="roles_id"
                        :items="roles"
                        @input="asignaRole"
                        :loading="asignando"
                        multiple
                        chips
                >
                    <template slot="selection" slot-scope="data">
                        <v-chip
                                :selected="data.selected"
                                :key="JSON.stringify(data.item)"
                                close
                                class="chip--select-multi"
                                @input="data.parent.selectItem(data.item)"
                        >
                            {{ data.item.name }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <user-select v-model="hijos"
                             multiple
                             label="Puede ver presupuestos de..."
                             @input="hijosSync"
                             prepend-icon="fa-dollar-sign"
                             :chips="true"
                ></user-select>
            </v-flex>
            <v-flex>
                <v-text-field
                        label="Descuento comercial hasta %"
                        v-model="desc_com"
                        @change="descuentoSet('com',desc_com)"
                        clearable
                        hint="Determina hasta que porcentaje tiene permitido el usuario aplicar de descuento COMERCIAL al precio de items del presupuesto"
                ></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field
                        label="Descuento estratégico hasta %"
                        v-model="desc_est"
                        @change="descuentoSet('est',desc_est)"
                        clearable
                        hint="Determina hasta que porcentaje tiene permitido el usuario aplicar de descuento ESTRATÉGICO al precio de items del presupuesto"
                ></v-text-field>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import usersMixin from '../../mixins/auth/users'
    import rolesMixin from '../../mixins/auth/roles'
    import permissionsMixin from '../../mixins/auth/permissions'
    import UserSelect from '../../components/UserSelect';
    import {mapActions} from 'vuex'

    export default {
        name: 'permisos',
        mixins: [usersMixin, rolesMixin, permissionsMixin],
        components: {UserSelect},
        data() {
            return {
                asignando: false,
                loading: -1,
                loadingAsig: -1,
                actualizando: false,
                role_id: '',
                roles_id: [],
                roles: [],
                hijos: [],
                user_id: '',
                grupo: '',
                permissions: [],
                permissions_id: [],
                loadingUser: false,
                tipo: 'perm',
                rutas: [],
                filtro: '',
                desc_com: '',
                desc_est: ''
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.rolesList(r => {
                    this.roles = r;
                }, err => {
                    console.log(err)
                });
                this.permissionsList(r => {
                    this.permissions = r;
                    this.userPermissionsGet();
                }, err => {
                    console.log(err);
                });
            },
            asignaRole() {
                this.asignando = true;
                this.userSyncRoles({
                    user_id: this.user_id,
                    roles_id: this.roles_id
                }, r => {
                    this.msj = r;
                    this.asignando = false;
                }, err => {
                    this.asignando = false;
                })
            },
            permissionSync() {
                this.asignando = true;
                this.userPermissionSync({
                    user_id: this.user_id,
                    permissions_id: this.permissions_id
                }, r => {
                    this.msj = r;
                    this.asignando = false;
                }, err => {
                    this.asignando = false;
                })
            },
            userSelected() {
                this.userPermissionsGet();
                this.userRolesGet();
                this.hijosGet();
                this.descuentoGet();
            },
            descuentoSet(tipo, desc) {
                if (!this.user_id) {
                    return false;
                }
                this.userDescuentoSet({
                    user_id: this.user_id,
                    desc: desc,
                    tipo: tipo
                }, r => {
                    this.msjShow(r)
                }, err => {
                    this.msjShow({tipo: err, txt: 'Error al asignar descuento'})
                })
            },
            descuentoGet() {
                this.userDescuentoGet({
                    user_id: this.user_id,
                }, r => {
                    this.desc_com = r.desc_com;
                    this.desc_est = r.desc_est;
                }, err => {
                    this.msjShow({tipo: err, txt: 'Error al obtener descuento'})
                })
            },
            userPermissionsGet() {
                if (!this.user_id) {
                    return false;
                }
                this.loadingUser = true;
                let self = this;
                this.permissions_id = [];
                this.userPermissions({user_id: this.user_id}, r => {
                    r.forEach((e) => {
                        self.permissions_id.push(e.id)
                    });
                    this.loadingUser = false
                }, err => {
                    alert(err)
                    this.loadingUser = false
                })

            },
            userRolesGet() {
                if (!this.user_id) {
                    return false;
                }
                this.loadingUser = true;
                this.roles_id = [];
                this.userRoles({
                    user_id: this.user_id
                }, r => {
                    r.forEach((e) => {
                        this.roles_id.push(e.id)
                    });
                    this.loadingUser = false
                }, err => {
                    console.log(err)
                    this.loadingUser = false
                })

            },
            hijosGet() {
                if (!this.user_id) {
                    return false;
                }
                this.usersHijos({
                    user_id: this.user_id
                }, r => {
                    r.forEach((e) => {
                        this.hijos.push(e.id)
                    });
                    this.loadingUser = false
                }, err => {
                    console.log(err)
                    this.loadingUser = false
                })
            },
            hijosSync() {
                this.asignando = true;
                this.userHijosSync({
                    user_id: this.user_id,
                    hijos: this.hijos
                }, r => {
                    this.msj = r;
                    this.asignando = false;
                }, err => {
                    this.asignando = false;
                })
            },
            actualizarPermisos() {
                this.actualizando = true;
                let rec = (arr) => {
                    arr.forEach(r => {
                        if (r.children) {
                            rec(r.children);
                        } else {
                            let name = (r.name) ? r.name : r.path;
                            let nombre = (r.nombre) ? r.nombre : name;
                            this.rutas.push({name: name, nombre: nombre})
                        }
                    })
                };
                rec(this.$router.options.routes);
                this.$http.post('permissions/actualiza-rutas', {rutas: this.rutas})
                    .then(r => {
                        this.datos();
                        this.actualizando = false;
                    })
                    .catch(err => {
                        console.log('Error al actualizar permisos', err)
                        this.actualizando = false;
                    })
            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/usuario_asignacion.vue